import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
	:root {
		--cream: ${({ theme }) => theme.design.bg};
		--panel: ${({ theme }) => theme.design.panel};
		--panel-2: ${({ theme }) => theme.design.panel2};
		--paper: ${({ theme }) => theme.design.paper};
		--ink: ${({ theme }) => theme.design.ink};
		--ink-rgb: ${({ theme }) => theme.design.inkRgb};
		--brown: ${({ theme }) => theme.design.brown};
		--mut: ${({ theme }) => theme.design.muted};
		--gold-ink: ${({ theme }) => theme.design.goldInk};
		--hair: rgba(var(--ink-rgb), 0.12);
		--scrim: ${({ theme }) =>
			theme.mode === 'dark'
				? 'rgba(9, 9, 10, 0.55)'
				: 'rgba(27, 20, 14, 0.35)'};
		--teal: ${({ theme }) => theme.design.teal};
		--teal-soft: ${({ theme }) => theme.design.tealSoft};
		--teal-deep: ${({ theme }) => theme.design.tealDeep};
		--teal-dark: ${({ theme }) => theme.design.tealDark};
		--coral: ${({ theme }) => theme.design.coral};
		--gold: ${({ theme }) => theme.design.gold};
		--black: ${({ theme }) => theme.design.black};
		--logo: ${({ theme }) => theme.design.logo};
		--fd: ${({ theme }) => theme.typography.fontPrimary};
		--fb: ${({ theme }) => theme.typography.fontSecondary};
		--fh: ${({ theme }) => theme.typography.fontHandwritten};
		--pad: ${({ theme }) => theme.layout.pad};
		--gut: ${({ theme }) => theme.layout.gut};
		--r: ${({ theme }) => theme.layout.radius};
		/* radius scale: --r for media/panels, then card, control, micro, pill */
		--r-card: 18px;
		--r-ctl: 14px;
		--r-xs: 8px;
		--r-pill: 999px;

		font-size: 16px;
		color-scheme: ${({ theme }) => (theme.name === 'dark' ? 'dark' : 'light')};
	}

	::selection {
		background: var(--teal);
		color: #1b140e;
	}

	body {
		background: var(--cream);
		color: var(--brown);
		font-family: var(--fb);
		font-size: 16.5px;
		line-height: 1.6;
		-webkit-font-smoothing: antialiased;
		overflow-x: hidden;
	}

	h1,
	h2,
	h3 {
		font-family: var(--fd);
		font-weight: 400;
		line-height: 1.02;
		letter-spacing: 0.2px;
		color: var(--ink);
		text-transform: uppercase;
	}

	/* currency code stays caps even inside lowercased buttons */
	.cur {
		text-transform: uppercase;
	}

	::-webkit-scrollbar-track {
		background: var(--cream);
	}

	::-webkit-scrollbar-thumb {
		border-radius: var(--r-card);
		background: rgba(var(--ink-rgb), 0.25);
	}

	/* scroll reveals (used via the Reveal motion primitive) */
	.rv {
		opacity: 0;
		transform: translateY(34px);
	}

	.rv.in {
		opacity: 1;
		transform: none;
		transition:
			opacity 0.9s cubic-bezier(0.2, 0.65, 0.25, 1),
			transform 0.9s cubic-bezier(0.2, 0.65, 0.25, 1);
	}

	.rv.d1.in {
		transition-delay: 0.08s;
	}

	.rv.d2.in {
		transition-delay: 0.16s;
	}

	.rv.d3.in {
		transition-delay: 0.24s;
	}

	@media (prefers-reduced-motion: reduce) {
		.rv {
			opacity: 1;
			transform: none;
		}
	}
`;
